//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import httpHelper from "../common/helpers/HttpHelper";
import environments from "../common/environments/environment";
const http = new httpHelper();

export const ErrorHandlerActions = {
    GetErrorHandlerJSON: getErrorHandlerJSON
}

function getErrorHandlerJSON() {
    return http.jsonGet(environments.CONTAINER_NAME + environments.ERROR_HANDLER);
}
